import LoggingAPI from "@/api/logging";
import { DefaultWebhookForm, WebhookFormData } from "@/Features";
import { useCreateWebhook } from "@/Features/Webhooks/webhooks.query";
import { usePermissions } from "@/hooks/usePermissions";
import { Button, styled } from "@monolith-forensics/monolith-ui";
import { ArrowLeftIcon } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  max-width: 700px;
  gap: 20px;
`;

const PageTitle = styled.h2``;

export const CreateNewWebhookPage = () => {
  const { currentUser } = usePermissions();
  const navigate = useNavigate();
  const webhookMutation = useCreateWebhook();
  const { mutate: createWebhook } = webhookMutation;

  const handleSubmit = (data: WebhookFormData) => {
    createWebhook(data);

    LoggingAPI.createLog({
      case_id: undefined,
      user_id: currentUser.user_id,
      message: `Created webhook: ${data.name}`,
      event: "webhook:create",
      object_type: "webhook",
      object_uuid: data.uuid,
    });

    navigate(`/settings/api/webhooks/${data.uuid}`);
  };

  return (
    <StyledContent>
      <Link to={"/settings/api"}>
        <Button
          size="xs"
          variant="text"
          leftSection={<ArrowLeftIcon size={16} />}
          style={{ color: "grey" }}
        >
          API Settings
        </Button>
      </Link>
      <PageTitle>Create New Webhook</PageTitle>
      <DefaultWebhookForm onSubmit={handleSubmit} />
    </StyledContent>
  );
};
